var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHurricaneLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "48px",
    viewBox: "0 0 36 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ABE38667-F033-49DA-8F02-711D814FF699") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Sprite",
    transform: "translate(-1009.000000, -2111.000000)",
    fill: "#696969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hurricane-light",
    transform: "translate(1009.000000, 2111.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,19.4898694 C3,11.0652859 9.20625,4.10625844 17.25,3 L17.25,9.16479063 C17.25,10.7154435 18.384375,11.9162539 19.7625,12.19991 C27.309375,13.7221972 33,20.4448447 33,28.5101306 C33,36.9347141 26.79375,43.8937416 18.75,45 L18.75,38.8352094 C18.75,37.2845565 17.615625,36.0837461 16.2375,35.80009 C8.690625,34.2778028 3,27.5551553 3,19.4898694 Z M20.25,2.96141625 C20.25,1.28059582 18.834375,-0.211368375 17.00625,0.0247019092 C7.415625,1.2617102 0,9.51472734 0,19.5052218 C0,29.0235757 6.721875,36.96498 15.646875,38.7591142 C15.69375,38.768557 15.721875,38.7874426 15.740625,38.8063282 C15.75,38.8157711 15.75,38.8157711 15.75,38.8157711 C15.75,38.8157711 15.75,38.8157711 15.75,38.8157711 L15.75,45.0385838 C15.75,46.7194042 17.165625,48.2113684 18.99375,47.9752981 C28.584375,46.7571754 36,38.5136011 36,28.5136638 C36,18.99531 29.278125,11.0539056 20.353125,9.25977144 C20.30625,9.25032863 20.278125,9.231443 20.259375,9.21255738 C20.25,9.20311457 20.25,9.19367176 20.25,9.19367176 L20.25,2.96141625 Z M22,24.5 C22,26.9852814 19.9852814,29 17.5,29 C15.0147186,29 13,26.9852814 13,24.5 C13,22.0147186 15.0147186,20 17.5,20 C19.9852814,20 22,22.0147186 22,24.5 Z M17.5,16 C13.3578644,16 10,19.3578644 10,23.5 C10,27.6421356 13.3578644,31 17.5,31 C21.6421356,31 25,27.6421356 25,23.5 C25,19.3578644 21.6421356,16 17.5,16 L17.5,16 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurricaneLight);
export default __webpack_public_path__ + "static/media/hurricane-light.64ce28ea08bfeedeb3dd02f86b2efa49.svg";
export { ForwardRef as ReactComponent };